import axios from "axios";
import useDataDevice from "hooks/useDataDevice";
import { useState } from "react";
import useUser from "state/User/useUser";

interface ISaveDataLog {
  idTransaction: string;
  message: string;
  path: string;
  status: number;
}

export const useInteractionLog = () => {
  const { user } = useUser();
  const { getBrowserName, getOS } = useDataDevice();
  const LOCAL_STORAGE_KEY = "2aiBNMiSlg";

  const [ip, setIP] = useState<string | null>(() =>
    localStorage.getItem(LOCAL_STORAGE_KEY)
  );

  const handleGetIP = async () => {
    if (!ip) {
      await fetch("https://api.ipify.org?format=json")
        .then((response) => response.json())
        .then((data: any) => {
          setIP(data.ip);
          localStorage.setItem(LOCAL_STORAGE_KEY, data.ip);
        })
        .catch((error) => {
          console.error("Error receiving data from IP API:", error);
        });
    }
  };

  const saveDataLog = async (params: ISaveDataLog) => {
    const { idTransaction, message, path, status } = params;
    const date = new Date();
    await handleGetIP();
    axios
      .post(
        process.env.REACT_APP_LOG_URL+"/log",
        {
          CodUsuario: user?.code,
          idUsuario: user?.id,
          rolUser: user?.role,
          idTransaccion: idTransaction,
          urlService: path ?? "",
          message: { messageError: message ?? "" },
          statusCode: status,
          ipOrigin: ip ?? "",
          browser: getBrowserName(),
          soVersion: getOS(),
          timestamp: date.toISOString(),
          ...(process.env.REACT_APP_ENV
            ? { environment: process.env.REACT_APP_ENV }
            : {}),
        },
        {
          headers: {
            "x-api-key": process.env.REACT_APP_LOGGING_API_KEY ?? "xxxxxx",
          },
        }
      )
      .then((response) => {
        console.log(response);
      })
      .catch((error) => {
        console.error("Error sending data to Log API:", error);
      });
  };

  return { saveDataLog,handleGetIP,ip };
};
